import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import {
    ECustomerProceduresActions,
    GetCustomerProcedures,
    GetCustomerProceduresFailure,
    GetCustomerProceduresSuccess
} from '../actions/customer-procedures.actions';
import { Store} from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { CustomerProcedureService } from '../../services/customer-procedure.service';
import { CustomerProcedureInterface } from '../../models/customer-procedure.interface';

@Injectable()
export class CustomerProceduresEffects extends AbstractEffects {

    procedureType: string = null;
    externalId: string = null;

    constructor(
      private actions: Actions,
      private customerProcedureService: CustomerProcedureService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getCustomerProcedures = createEffect(() => this.actions.pipe(
        ofType<GetCustomerProcedures>(ECustomerProceduresActions.GetCustomerProcedures),
        tap(params => { this.externalId = params.externalId; this.procedureType = params.procedureType; }),
        switchMap(() => this.customerProcedureService.get(this.procedureType, this.externalId)),
        switchMap((response: Array<CustomerProcedureInterface>) => of(new GetCustomerProceduresSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetCustomerProcedures(this.procedureType, this.externalId));
            } else if (500 <= error.status) {
                this.DisplayMessage('error_with_retry', 400, new GetCustomerProceduresFailure());
            }
            return throwError(error);
        })
    ));
}
